<template>

    <div class="reset-package-content">
        <h3>{{ t.__('Resetuj personalizację gier pakietu') }}</h3>

        <p>{{ t.__('Uwaga: Ta akcja trwale usunie wszystkie personalizacje dokonane w grach, przywracając je do oryginalnego stanu.') }}</p>

        <b-button variant="danger" @click="showConfirmModal">{{ t.__('Zresetuj personalizację gier') }}</b-button>

        <b-modal id="personalized-game-reset-package-confirm-modal" class="confirm-modal" size="sm" centered hide-header hide-footer>

            <div class="close-btn" @click="closeConfirmModal"></div>

            <div class="px-1 py-3">
                <p class="mb-3 text-center">{{ t.__('Czy napewno chcesz zresetować personalizację gier?') }}</p>
                <div class="row justify-content-center">
                    <div class="col-8">
                        <div class="row">
                            <div class="col-6">
                                <b-button variant="secondary" block @click="closeConfirmModal" :disabled="processing">{{ t.__('Anuluj') }}</b-button>
                            </div>
                            <div class="col-6">
                                <b-button variant="danger" block @click="resetPackage" :disabled="processing" v-text="processing ? t.__('Resetuję...') : t.__('Resetuj')"></b-button>
                            </div>
                        </div>
                    </div>
                </div>
            </div>

        </b-modal>

    </div>

</template>

<script>

export default {

    name: 'PersonalizedGameResetPackage',

    props: {
        packageIdentifier: String,
    },

    data() {
        return {
            eventHub: window.eventHub,
            processing: false
        }
    },

    computed: {

    },

    mounted() {

    },

    methods: {
        showConfirmModal() {
            this.$bvModal.show('personalized-game-reset-package-confirm-modal');
        },
        closeConfirmModal() {
            this.processing = false;
            this.$bvModal.hide('personalized-game-reset-package-confirm-modal');
        },
        resetPackage() {
            this.processing = true;
            axios.post('/personalized-games/reset-personalized-package/' + this.packageIdentifier, {})
                .then(response => {
                    this.closeConfirmModal()
                })
                .catch(error => {
                    console.log(error);
                });
        }
    }

}
</script>

<style scoped>

.reset-package-content {
    margin-bottom: 50px;

    h3 {
        font-size: 1.25rem;
        margin-bottom: 1rem;
    }

    p {
        font-size: 16px;
    }
}

</style>
